/**
 * @func validateZipCode
 * @param {string} value - The value to validate.
 * @return {boolean}
 * @desc Checks that the value is a valid zip code.
 * ```js
 * validateZipCode('12345');
 * // returns true
 *
 * validateZipCode('123');
 * // returns false
 * ```
 * @memberof module:Validators
 * @instance
 */
function validateZipCode(value) {
    return !!value.match(/^\d{5}$/);
}

export { validateZipCode as default };
